import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths, checkpoints } from 'src/constants';
import { useIntlMessages, useCheckpoint } from 'src/hooks';

import { Container } from './components';

const WheelOfFortuneCollections = ({
  getCollections,
  hasLoaded,
  pageCount,
  student,
  wheelOfFortuneCollections,
  wheelOfFortuneCurrency,
}) => {
  const messages = useIntlMessages();

  useCheckpoint(checkpoints.FIRST_TIME_ON_WHEEL_OF_FORTUNE, hasLoaded);

  return (
    <Container
      collectionsPath={paths.WHEEL_OF_FORTUNE}
      currency={wheelOfFortuneCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={wheelOfFortuneCollections}
      levelsPath={paths.WHEEL_OF_FORTUNE_LEVELS}
      pageCount={pageCount}
      student={student}
      title={messages.game.wheelOfFortune}
    />
  );
};

WheelOfFortuneCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  student: PropTypes.shape({}).isRequired,
  wheelOfFortuneCollections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  wheelOfFortuneCurrency: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.wheelOfFortuneCollections.getHasLoaded(state),
  wheelOfFortuneCurrency: selectors.wheelOfFortuneCollections.getCurrencyData(
    state
  ),
  wheelOfFortuneCollections: selectors.wheelOfFortuneCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.wheelOfFortuneCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.wheelOfFortune,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(WheelOfFortuneCollections);
